// Angular
import { ChangeDetectionStrategy, Component } from '@angular/core';

// EZ
import { DocMeta } from '@template-ui/decorators';
import { UiLibraryModule } from "@template-ui";

@DocMeta({
  title: 'Banner Panel',
  hide: true,
  category: 'Components',
  description: 'Demonstrates setting a panel banner message using default banner configuration.',
  showcaseTitle: 'Panel Built-In Banner',
  showcaseDesc: `
    ### Demonstrates the default banner built into the ez-panel updating only [bannerMessage].

    Click the button to set a random fortune-cookie style message.

    Does not require the banner component nor even a reference to the banner service.
  `,
  showcaseComponentNames: ['EzBannerPanelSampleComponent']
})
@Component({
  selector: 'ui-banner-panel-sample, ez-banner-panel-sample',
  standalone: true,
  imports: [UiLibraryModule],
  templateUrl: './ez-banner-panel-sample.component.html',
  styleUrls: ['./ez-banner-panel-sample.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EzBannerPanelSampleComponent {

  /** Banner message content pushed through the panel input. */
  protected bannerMessage = '';

  private readonly fortunes: readonly string[] = [
    'Small progress today becomes big progress tomorrow.',
    'The cleanest fix is usually the one you can explain in one sentence.',
    'A calm mind catches the bug faster than a rushed one.',
    'Write the test your future self wishes existed.',
    'Simple code is a long-term performance optimization.',
    'Good naming saves more time than good comments.'
  ];

  /** Sets a random wisdom message to demonstrate banner updates. */
  protected showRandomWisdom(): void {
    const index = Math.floor(Math.random() * this.fortunes.length);

    // This is all you need to do to set the message.
    this.bannerMessage = this.fortunes[index];
  }
}
